import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export const overlaySliceName = "overlay";

export interface OverlayState {
  overlayViewName: string | null;
}

const initialState: OverlayState = {
  overlayViewName: null,
};

const overlaySlice = createSlice({
  name: overlaySliceName,
  initialState,
  reducers: {
    updateOverlay(state: OverlayState, { payload }: PayloadAction<string | null>) {
      state.overlayViewName = state.overlayViewName === payload ? null : payload;
    },
  },
});

export interface OverlayRootState {
  [overlaySliceName]: OverlayState;
}

export const selectOverlay = (state: OverlayRootState) => state[overlaySliceName].overlayViewName;

export const { updateOverlay } = overlaySlice.actions;

export const overlayReducer = overlaySlice.reducer;
